import { useState } from "react";
import { Archive } from "lucide-react";
import { ARCHIVE_REASONS, AUTO_REASONS } from "../lib/constants";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export const ArchiveDialog = ({ open, setOpen, count, onConfirm, name }) => {
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = reason && (reason !== "other" || note.trim());

  const close = (o) => { setOpen(o); if (!o) { setReason(null); setNote(""); } };
  const submit = async () => {
    setBusy(true);
    const ok = await onConfirm(reason, note.trim());
    setBusy(false);
    if (ok) close(false);
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md" data-testid="archive-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Archive className="h-5 w-5 text-blue-700" />Move {name || `${count} lead${count === 1 ? "" : "s"}`} to Dead deals</DialogTitle>
          <DialogDescription>Why? They stay viewable under Dead deals and can be restored anytime.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {ARCHIVE_REASONS.map((r) => (
            <button key={r.value} onClick={() => setReason(r.value)} data-testid={`archive-reason-${r.value}`}
              className={`h-11 rounded-xl border text-sm font-medium transition-colors ${reason === r.value ? "!bg-blue-700 border-blue-700 !text-white ring-2 ring-blue-300 ring-offset-1 font-semibold" : "border-slate-200 text-slate-700 hover:border-blue-300"}`}>
              {r.label}
            </button>
          ))}
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} data-testid="archive-note-input"
          placeholder={reason === "other" ? "What's the reason? (required)" : "Add a note (optional)"} />
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={() => close(false)} data-testid="archive-cancel">Cancel</Button>
          <Button disabled={!ready || busy} onClick={submit} className="rounded-full bg-blue-700 hover:bg-blue-800" data-testid="archive-confirm">Move to Dead deals</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const ReasonFilter = ({ value, onChange }) => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid="archive-reason-filter">
    {[{ value: "all", label: "Any reason" }, ...ARCHIVE_REASONS, ...AUTO_REASONS].map((r) => (
      <button key={r.value} onClick={() => onChange(r.value)} data-testid={`archive-filter-${r.value}`}
        className={`h-8 px-3 rounded-full text-xs font-semibold border transition-colors ${value === r.value ? "bg-slate-900 border-slate-900 text-white" : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"}`}>
        {r.label}
      </button>
    ))}
  </div>
);
